require('./feature-popup-content/feature-popup-content.scss');
var Button = require('treeline-shared-components/button.js');
var DefaultView = require('./feature-popup-content/feature-popup-content-default-view.js');
var FeaturePopupContent = Marionette.LayoutView.extend({
  template: require('./feature-popup-content/feature-popup-content-layout.tpl'),
  className: 'feature-popup-content container-fluid',
  initialize: function (options) {
    this.options = _.defaults(
        options || {},
        {
            contentView: undefined,
            mode: 'view' // view || edit
        }
    );
    this.model = this.options.model || new Backbone.Model();
  },
  regions: {
    contentRegion: '.content-region',
    selectBtnRegion: '.select-btn-region'
  },
  _renderSelectButton: function () {
    var self = this;
    this._selectBtn = new Button.Button({
        label: 'SELECT THIS LOCATION',
        enabled: true,
        classNames: 'fmcy-feature-popup-content-action-btn',
        theme: Button.THEMES.DEFAULT,
        onClickedCallback: function () {
            self.trigger('feature:selected');
        }
    });

    this.selectBtnRegion.show(this._selectBtn);
  },

  onRender: function () {
    var self = this;
    if (this.options.childView != undefined) {
      this.contentView = this.options.childView;
      this.contentRegion.show(this.contentView);
    } else {
      this.contentView = new DefaultView(this.options);
      this.contentRegion.show(this.contentView);
      if (this.options.temp_closed !== '1') {
        this._renderSelectButton();
      }
    }
  }
});

module.exports = FeaturePopupContent;



/** WEBPACK FOOTER **
 ** ./assets/js/common/locations-map/feature-popup-content.js
 **/